import React from 'react';
// @ts-ignore
import styles from './PlusButton.module.scss';
import Text from '../../Base/Text/Text';

interface Props {
	item: {
		title: string;
		type: string;
	};
	onClick: (type: string) => void;
}

const PlusButton: React.FC<Props> = ({ item, onClick }) => {
	return (
		<>
			<div className={styles.wrapper} onClick={() => onClick(item.type)}>
				<div className={styles.icon} />
				<div className={styles.title}>
					<Text tx={item.title} inline />
				</div>
			</div>
		</>
	);
};

export default PlusButton;
